import { render, staticRenderFns } from "./MenuItemPeriod.vue?vue&type=template&id=fa9c7342&scoped=true&"
import script from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
export * from "./MenuItemPeriod.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemPeriod.vue?vue&type=style&index=0&id=fa9c7342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9c7342",
  null
  
)

export default component.exports